/* eslint-disable no-useless-escape */
import moment from 'moment/moment';
import { obj } from '../models/common-types';

export const capitalizeFirstLetter = (str, onlyFirstLetter?) =>
    str ? `${str.charAt(0).toUpperCase()}${onlyFirstLetter ? str.slice(1) : str.slice(1).toLowerCase()}` : '';

export const numberPrettier = (input: number | string) => {
    let result;
    if (input || input === 0) {
        result = input.toString();
        // @ts-ignore
        if (input >= 1_000_000) {
            result = `${(parseInt(result) / 1000000).toFixed(1).replace(/\.?0+$/, '')}M`;
        } else {
            // @ts-ignore
            if (input >= 1000) {
                result = `${result.substring(0, result.length - 3)},${result.substring(result.length - 3)}`;
            }
        }
    }
    return result;
};

export const dateFormatter = (dateObj: obj<string> | string, format?: string) => {
    if (!dateObj) return '-';
    if (typeof dateObj === 'string') {
        if (!moment(dateObj).isValid()) {
            return dateObj;
        } else {
            const finalFormat = format
                ? format
                : dateObj.length === 4
                  ? 'YYYY'
                  : dateObj.length === 7
                    ? 'MMM, YYYY'
                    : dateObj.length === 10
                      ? 'MMM D, YYYY'
                      : 'MMM D, YYYY | hh:mm a';
            return moment(dateObj).format(finalFormat);
        }
    }

    const { day, month, year, start, end } = dateObj;

    if (start || end) {
        return start && end && start !== end
            ? `${moment(start).format('LL')} - ${moment(end).format('LL')}`
            : moment(start || end).format('LL');
    } else if (day || month || year) {
        let format = `${month ? 'MMM' : ''} ${day ? 'D' : ''} ${year ? 'YYYY' : ''}`.trim();
        let date = `${month || '01'} ${day || '01'} ${year || '2000'}`;

        return moment(date).format(format);
    } else {
        return '-';
    }
};

export const toMoment = (date: string | Date | moment.Moment) => (date ? moment(date) : date);

export const formatPhoneNumber = (value: { countryCode?: string; phone?: string }): string =>
    `${value.countryCode ? `+${value.countryCode}` : ''}${value.phone || ''}`;

export const dateRangeFormatter = (start: string | null, end: string | null) =>
    !start ? null : `${moment(start).format('LL')} - ${end ? moment(end).format('LL') : 'Present'}`;

export const containsSpecialCharacters = (str: string): boolean => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(str);

export const containsDigits = (str: string): boolean => /[0-9]/.test(str);

export const containsUpperCase = (str: string): boolean => /[A-Z]/.test(str);

export const isValidDateRange = (dateRange: any): boolean => {
    return dateRange && dateRange?.[0] && dateRange?.[1];
};

export const formatUrl = (url: any): any => {
    return !url || url.startsWith('http') ? url : `https://${url}`;
};

export const stringToHexColor = (str) => {
    // Step 1: Calculate the hash of the string
    let hash = 0;
    for (let i = 0; i < str?.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Step 2: Convert the hash to a hexadecimal color code
    let color = '#';
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xff;
        color += ('00' + value.toString(16)).slice(-2);
    }

    return color;
};
